export default function sw() {
    if ('serviceWorker' in navigator) {
        let swUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;
        navigator.serviceWorker
            .register(swUrl)
            .then(response => {
                // response.onupdatefound = () => {
                //     const installingWorker = response.installing;
                //     installingWorker.onstatechange = () => {
                //         if (installingWorker.state === 'installed') {
                //             if (navigator.serviceWorker.controller) {
                //                 // At this point, the old content will have been purged and
                //                 // the fresh content will have been added to the cache.
                //                 // It's the perfect time to display a "New content is
                //                 // available; please refresh." message in your web app.
                //                 alert('New content is available; please refresh.');
                //             } else {
                //             }
                //         }
                //     };
                // };
            })
            .catch(err => {});
    }
}
